import { MinusCircleOutlined } from "@ant-design/icons";
import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import Button from "../Page/Components/Button";
import Line from "../Page/Components/Line";
import ProgramTitle from "../Page/Components/ProgramTitle";
import DefaultLayout from "../Page/DefaultLayout";

const ErrorIcon = styled(MinusCircleOutlined)`
  font-size: 30px;
  color: #717171;
`;

const NotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <>
      <DefaultLayout>
        <ProgramTitle>안내</ProgramTitle>
        <Line />
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <ErrorIcon />
          <div
            style={{
              margin: "20px 0px 10px 0px",
              color: "#717171",
              fontSize: "13px",
            }}
          >
            <p>잘못된 접근입니다.</p>
            <p>지속적으로 문제 발생시 관리자에게 연락주시기 바랍니다.</p>
          </div>
          <Button widthSize="150px" onClick={goHome}>
            홈으로 이동
          </Button>
        </div>
      </DefaultLayout>
    </>
  );
};

export default NotFound;
